<template>
  <div>
    <div class="col-lg-9 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn padbtn">
          <button class="btn btn-secondary" @click="$router.go(-1);">
            <i class="fa fa-chevron-left"></i>
            Regresar
          </button>
        </div>
        <hr />
        <form v-if="canCreate() || canUpdate()" @submit.prevent="validateForm">
          <div class="row">
            <div class="col-md-6">
              <fg-input
              type="text"
              label="Nombre *"
              v-model="moduleForm.name_module"
              v-validate="modelValidations.name_module"
              name="nombre del modulo"
              :error="getError('nombre del modulo')"
              :disabled="disabledField">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
              type="text"
              label="URL"
              v-model="moduleForm.url">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <fg-input
              type="text"
              label="Icono"
              v-model="moduleForm.icon">
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
              type="number"
              label="Orden *"
              v-model="moduleForm.order"
              v-validate="modelValidations.order"
              name="orden del modulo"
              :error="getError('orden del modulo')">
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <label>Nivel *</label>
              <el-select
              filterable :class="selectClassLevel"
              class="select_modules"
              size="large"
              placeholder="Seleccione un nivel"
              v-model="moduleForm.level">
                <el-option
                label="Nivel 1"
                key="Nivel 1"
                value="1">
                </el-option>
                <el-option
                label="- Nivel 2"
                key="- Nivel 2"
                value="2">
                </el-option>
                <el-option
                label="-- Nivel 3"
                key="-- Nivel 3"
                value="3">
                </el-option>
                <el-option
                label="--- Nivel 4"
                key="--- Nivel 4"
                value="4">
                </el-option>
              </el-select>
            </div>
            <div class="col-lg-6">
              <label>Padre *</label>
              <el-select  :class="selectClassParent" class="select_modules"
                          v-model="moduleForm.parent_module"
                          filterable placeholder="Seleccione un modulo padre">
                <el-option class="select-primary"
                          label="/"
                          key="0"
                          value="0">
                </el-option>
                <el-option v-for="option in modules"
                            class="select-primary"
                            :value="option.id"
                            :label="option.name_module"
                            :key="option.name_module"
                            >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <fg-input
              label="Descripción">
                <textarea v-model="moduleForm.description" class="form-control" rows="3">
                </textarea>
              </fg-input>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label>Perfiles</label>
              <el-select  multiple class="select-primary select_modules"
              v-model="moduleForm.roles"
              filterable placeholder="Seleccione uno o varios perfiles">
                <el-option v-for="option in roles"
                            class="select-primary"
                            :value="option.id"
                            :label="option.name"
                            :key="option.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="row" v-if="errorAlert ">
            <div class="col-lg-12">
              <el-alert
                :title="errorAlert"
                type="error">
              </el-alert>
            </div>
          </div><br><hr><br>
          <div class="text-center">
            <button type="submit" class="btn btn-fill btn-warning btn-wd">
              Guardar
            </button>
          </div>
        </form>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para crear o editar </strong></h4>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import store from '@/store'

  export default {
    data () {
      return {
        moduleForm: {
          name_module: null,
          url: null,
          icon: null,
          description: null,
          order: null,
          level: null,
          parent_module: null,
          roles: null
        },
        modelValidations: {
          name_module: {
            required: true,
          },
          order: {
            required: true,
          },
        },
        roles: null,
        modules: null,
        selectClassParent: 'select-primary',
        selectClassLevel: "select-primary",
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods:{
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            if( this.moduleForm.level && this.moduleForm.parent_module) this.storeUpdateModule()
            else if(!this.moduleForm.parent_module){
              this.selectClass2 = 'select-danger'
              this.errorAlert = 'Debe seleccionar un modulo padre'
              setTimeout(()=>{
                this.selectClassParent = 'select-primary'
                this.errorAlert = null
              }, 5000)
            } else {
              this.selectClass = 'select-danger'
              this.errorAlert = 'Debe seleccionar un nivel'
              setTimeout(()=>{
                this.selectClass = "select-primary"
                this.errorAlert = null
              }, 5000)
            }
          }
        })
      },
      storeUpdateModule(){
        this.$emit('cotentLoading', true)
        this.moduleForm.route = 'modules'
        if (localStorage.getItem('moduleEdit')) {
          this.updateMaster(this.moduleForm).then((response)=>{
            this.$emit('cotentLoading')
            showSwalAlert(response.data.message, 'success', false).then(()=> this.$router.push('/modules'))
          }).catch((error) => {
            this.$emit('cotentLoading')
            if(error.response.data.errors.name_module) showSwalAlert(error.response.data.errors.name_module[0], 'error', false)
          })
        } else {
          this.saveMaster(this.moduleForm).then((response)=>{
            this.$emit('cotentLoading')
            showSwalAlert(response.data.message, 'success', false).then(()=> this.$router.push('/modules'))
          }).catch((error) => {
            this.$emit('cotentLoading')
            if(error.response.data.errors.name_module) showSwalAlert(error.response.data.errors.name_module[0], 'error', false)
          })
        }
      },
    },
    created(){
      if(this.canCreate() || this.canUpdate()){
        if (localStorage.getItem('moduleEdit')) {
          this.$emit('cotentLoading', true)

          setTimeout(() => {
            this.disabledField = true
            this.moduleForm = JSON.parse(localStorage.getItem('moduleEdit'))
            if(!this.moduleForm.parent_module) this.moduleForm.parent_module = '0'
            this.title = 'Editar Modulo '+this.moduleForm.name_module
            this.$emit('cotentLoading')
          }, 1000);

        }
        else this.title = 'Agregar un Modulo'
        this.getMasters('roles/index').then((response) => this.roles = response.data.data).catch((error) => this.showMessageErrors(error))
        this.getMasters('modules/index').then((response) => this.modules = response.data.data).catch((error) => this.showMessageErrors(error))
      }
    },
    beforeDestroy(){
      localStorage.removeItem('moduleEdit');
    }
  }
</script>
